var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemoryStrength(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2980",
    fill: "none",
    d: "M0 0h40v40H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4387"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2160",
    d: "M13.344 31l3.962-9.245a.734.734 0 00-.674-1.023h-2.897a.732.732 0 01-.67-1.024L17.549 9.44a.733.733 0 01.672-.44h7.53a.733.733 0 01.572 1.192l-3.958 4.951a.733.733 0 00.573 1.191h3.307a.733.733 0 01.52 1.253z",
    stroke: "#575757",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "none"
  }))));
}
export default SvgIconMemoryStrength;